module.exports = __webpack_public_path__ + "img/fund-wallet-icon.4226af15.svg";